<div class="">
  <div class="page-content" style="padding-bottom: 120px;">
    <div class="row">
      <div class="col-md-6">
        <h2 class="heading1">{{'Language.Setting' | translate}}</h2>
      </div>
      <div class="col-md-6 text-end">
        <button *ngIf="canAdd" mat-raised-button class="primary-btn" (click)="openDialog1()">
          {{'Language.SetRateSelectionText' | translate}}
        </button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <h3 class="heading2">{{'Language.ExchangeRateMasterText' | translate}}</h3>
      </div>
    </div>

    <fieldset [disabled]="(getFormMode == 0 && !canAdd) || (getFormMode == 1 && !canEdit)" class="view-mode-fieldset"
      style="border: none; padding: 0; margin: 0;">
      <div class="d-flex field-bottom-0 mb-2">
      
        <div class="w-month">
          <mat-form-field class="me-2" appearance="outline">
            <mat-label>{{'Language.MonthText' | translate}}</mat-label>
            <mat-select name="CurrentMonth" [(ngModel)]="this.getEntryFormDataSource.currentMonth"
              (selectionChange)="onChangeMonthAndYear($event)" [disabled]="!canEdit">
            <mat-option *ngFor="let month of lstMonth" [value]="month.id">
              {{month.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="w-year">
        <mat-form-field class="" appearance="outline">
          <mat-label>{{'Language.YearText' | translate}}</mat-label>
          <mat-select name="CurrentYear" [(ngModel)]="this.getEntryFormDataSource.currentYear"
            (selectionChange)="onChangeMonthAndYear($event)" [disabled]="!canEdit">
            <mat-option *ngFor="let year of lstYear" [value]="year.id">
              {{year.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>
    <!-- <div class="row">
      <div *ngFor="let col1 of test1">
        {{col1.rateDate}}
        <div *ngFor="let td1 of col1.exchangeRatesAndIndexesResponseListDtos">
          {{td1.rate}}
          {{td1.currency}}
        </div>
      </div>
    </div> -->

    <div class="row">
      <div class="col-md-12 tabledesign exchangerategrid">
        <table mat-table [dataSource]="lstData">
          <ng-container [matColumnDef]="col" *ngFor="let col of displayedColumns">
            <th mat-header-cell *matHeaderCellDef>
              {{col}}
            </th>
            <td mat-cell *matCellDef="let item;let i = index">
              <mat-form-field class="field-bottom-0 mt-2 mb-2" appearance="outline">
                <input type="text" matInput [(ngModel)]="item[col]" [readonly]="col == 'Date' ? 'true' : 'false'"
                  (keyup)="isPressed=true" [disabled]="item.isDisabled || !canEdit" numbersOnly maxlength="10"
                  (ngModelChange)="btnEvent($event)">
              </mat-form-field>
              <!-- <i-feather style="margin-left: 5px;" class="t-icon pointer" name="edit-2" (click)="onChangeCurrency(item)" *ngIf="col!='Date'">
              </i-feather> -->
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
          <tr mat-row class="cursor-pointer" *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

      </div>
    </div>
    </fieldset>

  </div>

  <div class="mt-2 footer">
    <div class="">
      <button *ngIf="(getFormMode == 0 && canAdd) || (getFormMode == 1 && canEdit)" #buttonSave mat-raised-button color="primary" (click)="onSave()" [disabled]="!isPressed">
        {{ isPressed ? ("Language.UpdateText" | translate) : ("Language.OkText" | translate)}}
      </button>
      <button class="me-2" #buttonCancel mat-raised-button (click)="onClickOfGenericCancelButton($event)">
        {{'Language.CancelText' | translate }}
      </button>
    </div>
  </div>


</div>